import { render, staticRenderFns } from "./FormStats.vue?vue&type=template&id=423ee7a4&scoped=true&"
import script from "./FormStats.vue?vue&type=script&lang=js&"
export * from "./FormStats.vue?vue&type=script&lang=js&"
import style0 from "./FormStats.vue?vue&type=style&index=0&id=423ee7a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ee7a4",
  null
  
)

export default component.exports